import {DISCOVERY_TYPES_OPTIONS, DISCOVERY_TYPES_REQUIRES_REFERRER_OPTIONS} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator"
import {transformValidationResultToArray} from "@utils/validation-markup-generator";

export const ValidateStep0Data = (data) => {
   
   /*const msgList = [];

   return msgList;*/
   
   
   const rules = [
      {
         field_name: 'discountCode',
         field_label: 'Discount code',
         rules: [
            {
               name: 'nullable',
            },
            {
               name: 'string'
            },
            {
               name: 'max_length',
               data: {
                  length: 20
               }
            },
         ]
      },
      {
         field_name: 'discoveryType',
         field_label: 'Discovery type',
         rules: [
            {
               name: 'nullable',
            },
            {
               name: 'string'
            },
            {
               name: 'in_array',
               data: {
                  array: DISCOVERY_TYPES_OPTIONS?.map((item) => {
                     return item.value
                  })
               }
            },
         ]
      },
      {
         field_name: 'referrersName',
         field_label: `Referrer's name`,
         rules: [
            {
               name: "nullable",
            },
            {
               name: "string",
            },
            {
               name: "max_length",
               data: {
                  length: 50
               }
            }
         ]
      },
      {
         field_name: 'contactEmail',
         field_label: 'Contact email',
         rules: [
            {name: 'required'},
            {name: 'string'},
            {name: 'email'},
         ]
      },
      {
         field_name: 'contactPhone',
         field_label: 'Contact phone',
         rules: [
            {name: 'required'},
            {name: 'string'},
         ]
      }
   ];
   
   const validator = new ObjetDataValidator({
      data,
      rules
   });
   
   const result = validator.validate();
   
   if (result === true) {
      return [];
   } else {
      return transformValidationResultToArray(result);
   }
   
}